<template>
  <router-view />
</template>

<script>
export default {
  name: 'page-view'
}
</script>
